import { formatApiResponse } from '@utils/helpers';
import { api, protectedApi } from '@api';
import { getRefreshToken } from '@contexts/authContext';

export const ACCESS_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';

export const loginApi = async (email, password, keep_logged_in) => {
  try {
    const res = await api.post('/login', { email, password, keep_logged_in });
    return formatApiResponse(res);
  } catch (e) {
    return formatApiResponse(e);
  }
};

export const logoutApi = async () => {
  const refreshToken = {
    refresh: getRefreshToken()
  };
  try {
    const res = await protectedApi.post('/logout', refreshToken);
    if (res.status === 204) {
      window.localStorage.removeItem(ACCESS_TOKEN_KEY);
      window.localStorage.removeItem(REFRESH_TOKEN_KEY);
    }
    return formatApiResponse(res);
  } catch (e) {
    return formatApiResponse(e);
  }
};

export const getSessionApi = async () => {
  try {
    const res = await protectedApi.get('/session');
    return formatApiResponse(res);
  } catch (e) {
    return formatApiResponse(e);
  }
};

export const forgotPasswordAPI = async (email) => {
  try {
    const res = await api.post('/forgot-password', { email });
    return formatApiResponse(res);
  } catch (e) {
    return formatApiResponse(e);
  }
};

export const changePasswordApi = async (old_password, new_password) => {
  try {
    const res = await protectedApi.patch('/change-password', {
      old_password,
      new_password
    });
    return formatApiResponse(res);
  } catch (e) {
    return formatApiResponse(e);
  }
};

export const resetPasswordAPI = async (password, uidb64, token) => {
  try {
    const res = await api.patch('/set-password/', {
      password,
      uidb64,
      token
    });
    return formatApiResponse(res);
  } catch (e) {
    return formatApiResponse(e);
  }
};
